import { gql } from '@apollo/client'

export const GET_CONTINUE_LESSONS = gql`
  query getContinueLessons {
    user {
      id
      lastViewedContents {
        completed
        id
        enrollment {
          id
          activatedAt
          status
          courseClassRelease {
            enabled
            startAt
            defaultOffset
          }
        }
        progressCard {
          id
          courseId
        }
        lesson {
          id
          courseContentId
          title
          releaseAt
          releaseAfter
          courseClassReleaseOffset
          lockAt
          lockAfter
          activity {
            id
            examQuestionsCount
          }
          coverImage {
            cdnFileUrl
          }
          media {
            id
            type
            originUrl
            providerKey
            fileExt
            hostKey
            host
            organizationUuid
            text
          }
        }
        schoolProduct {
          id
          title
          courses {
            id
            kind
          }
        }
        progress
      }
    }
  }
`
